const state = () => ({
  userToken: null,
  partnerUrl: null,
  clientId: null,
  productCode: null,
  externalRegistrationDialog: false,
  partnerSelected: null,
  checkTokenLoading: false,
  tokenValid: null
});

const getters = {
  userToken(state) {
    return state.userToken;
  },
  partnerUrl(state) {
    return state.partnerUrl;
  },
  clientId(state) {
    return state.clientId;
  },
  productCode(state) {
    return state.productCode;
  },
  externalRegistrationDialog(state) {
    return state.externalRegistrationDialog;
  },
  partnerSelected(state) {
    return state.partnerSelected;
  },
  checkTokenLoading(state) {
    return state.checkTokenLoading;
  },
  tokenValid(state) {
    return state.tokenValid;
  }
};

const mutations = {
  setUserToken(state, payload) {
    state.userToken = payload;
  },
  setPartnerUrl(state, payload) {
    state.partnerUrl = payload;
  },
  setClientId(state, payload) {
    state.clientId = payload;
  },
  setProductCode(state, payload) {
    state.productCode = payload;
  },
  setExternalRegistrationDialog(state, payload) {
    state.externalRegistrationDialog = payload;
  },
  setPartnerSelected(state, payload) {
    state.partnerSelected = payload;
  },
  setCheckTokenLoading(state, payload) {
    state.checkTokenLoading = payload;
  },
  setTokenValid(state, payload) {
    state.tokenValid = payload;
  },
  resetStore(s) {
    Object.assign(s, state());
  }
};

const actions = {
  setExternalRegistrationDialog({ commit }, payload) {
    commit('setExternalRegistrationDialog', payload);
  },
  setCheckTokenLoading({ commit }, payload) {
    commit('setCheckTokenLoading', payload);
  },

  setExternalPartner({ commit }, payload) {
    commit('setPartnerUrl', payload.partnerUrl);
    commit('setProductCode', payload.productCode);
    commit('setClientId', payload.clientId);
    commit('setUserToken', payload.userToken);
  },

  resetExternalPartner({ commit }) {
    commit('setPartnerUrl', null);
    commit('setProductCode', null);
    commit('setClientId', null);
    commit('setUserToken', null);
    commit('setTokenValid', null);
  },

  async checkRegistrationToken({ state, commit, dispatch }, region) {
    commit('setCheckTokenLoading', true);
    commit('setExternalRegistrationDialog', true);

    let url = `/v3/fe/partners/check-registration-token?region=${region}&partnerUrl=${state.partnerUrl}&userToken=${state.userToken}`;

    if (state.clientId) {
      url += `&clientId=${state.clientId}`;
    }

    if (state.productCode) {
      url += `&productCode=${state.productCode}`;
    }

    await this.$http
      .get(url, { headers: { Authorization: '' } })
      .then(data => {
        if (data?.isValidUserToken) {
          if (!this.$auth.isLoggedIn) {
            commit('setExternalRegistrationDialog', false);
          }
          commit('setTokenValid', true);

          if (data?.isRegistered && data?.email) {
            commit('profile/login/setEmail', data?.email, { root: true });
          }
        } else {
          commit('setTokenValid', false);
          commit('setPartnerSelected', data.partner);
        }
      })
      .catch(err => {
        dispatch('errorModal/handleError', { error: err, code: '0x0000005E' }, { root: true });
      })
      .finally(() => {
        commit('setCheckTokenLoading', false);
      });
  }
};

export const externalPartner = {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
